import { Sports } from 'common/enums/sport/sports.enum';
import * as Yup from 'yup';
export var createCommunityValidationSchema = Yup.object().shape({
    name: Yup.string()
        .trim()
        .min(1, 'createCommunityValidationSchema_name_min')
        .max(128, 'Слишком длинный текст ссылки. Пожалуйста, введите от 1 до 128 символов')
        .required('Не указан текст ссылки'),
    sport: Yup.mixed().oneOf(Object.values(Sports)).required('activityValidationSchema_sport_required')
});
export var updateCommunityValidationSchema = Yup.object().shape({
    name: Yup.string()
        .trim()
        .min(1, 'createCommunityValidationSchema_name_min')
        .max(128, 'Слишком длинный текст ссылки. Пожалуйста, введите от 1 до 128 символов')
        .optional()
        .nullable(),
    allUsersCanJoin: Yup.boolean(),
    joinViaLink: Yup.boolean(),
    joinViaCode: Yup.boolean(),
    joinViaRequest: Yup.boolean(),
    userMustBeTelegramChatMember: Yup.boolean(),
    joinCode: Yup.string()
        .trim()
        .min(4, 'Код должен быть не менее 4 символов и не более 12.')
        .max(12, 'Код должен быть не менее 4 символов и не более 12.')
        .matches(/^([a-zA-Z0-9]+)$/, 'Код может состоять из латинских букв и цифр')
        .optional()
        .nullable()
});
